import { useEffect } from "react";
import { nativeRuntime } from "./native";
import type { User } from "../api/types";
import { useDismissTopic } from "../api/queries/auth";

export const DISMISS_ANDROID_COOKIE = "jt_dismiss_android_popup";

export function isAndroidWeb(customUa?: string): boolean {
  if (nativeRuntime() !== null) return false;
  const ua = customUa ?? (typeof navigator !== "undefined" ? navigator.userAgent : "");
  return /android/i.test(ua);
}

export function getDismissAndroidPopupCookie(): boolean {
  if (typeof document === "undefined") return false;
  return document.cookie.split("; ").some((c) => c.startsWith(`${DISMISS_ANDROID_COOKIE}=1`));
}

export function setDismissAndroidPopupCookie(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${DISMISS_ANDROID_COOKIE}=1; path=/; max-age=315360000; SameSite=Lax`;
}

export function shouldShowAndroidPopup(options: {
  isAndroid: boolean;
  cookieDismissed: boolean;
  meDismissed?: boolean;
}): boolean {
  if (!options.isAndroid) return false;
  if (options.cookieDismissed) return false;
  if (options.meDismissed) return false;
  return true;
}

export function useAndroidPopupSync(me: User | null | undefined): void {
  const dismissMutation = useDismissTopic();

  useEffect(() => {
    if (!me) return;
    const cookiePresent = getDismissAndroidPopupCookie();
    const hasDbDismissal = me.dismissals?.includes("android_popup");

    if (hasDbDismissal && !cookiePresent) {
      setDismissAndroidPopupCookie();
    }
    if (!hasDbDismissal && cookiePresent && !dismissMutation.isPending) {
      dismissMutation.mutate("android-popup");
    }
  }, [me, dismissMutation]);
}
